<template>
  <ul class="left-menu">
    <li>
      <a
        href="#"
        class="js-sidebar-open"
        @click="closeMenu()"
      >
        <app-icon
          name="olymp-close-icon"
          color="dark-gray"
          size="normal"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Collapse Menu</span></a>
    </li>

    <li>
      <router-link to="/courses">
        <app-icon-multiple
          name="nico-menu-tickets"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Spiritual Courses</span>
      </router-link>
      <a href="#" />
    </li>
  </ul>
</template>

<script>
// eslint-disable-next-line
// import Ps from 'perfect-scrollbar';
// eslint-disable-next-line
// import '../../../css/perfect-scrollbar.css';
import AppIconMultiple from '../AppIconMultiple'
import AppIcon from '../AppIcon'

export default {
  name: 'FamilialLarge',
  components: {AppIcon, AppIconMultiple},
  props: {
    // openMenuVar: {
    //   type: Boolean,
    //   default: false
    // }
  },
  // computed: {
  //   openMenu() {
  //     return this.openMenuVar;
  //   },
  // },
  data () {
    return {
      openMenu: true,
    }
  },
  watch: {
    // openMenuVar() {
    //   // this.openMenu = this.openMenuVar;
    //   console.log(this.openMenuVar);
    // },
  },
  methods: {
    // getLink (item) {
    //   return `/${this.ppa}/${item}`
    // },
    // getLinkArticle() {
    //   return ['personal', 'nlp'].includes(this.ppa)
    // },
    closeMenu() {
      this.openMenu = !this.openMenu
      this.$emit('openmenu', false);
    }
  },
}
</script>
